<rt-dialog-header
  [heading]="'app.offers.manage_referrals.dialog.heading' | translate"
  [subheading]="'app.offers.manage_referrals.dialog.subheading' | translate: { count: jobsCount }"
>
</rt-dialog-header>
<rt-dialog-body layout-vertical>
  <rt-new-item-button
    [heading]="'app.offers.manage_referrals.dialog.enable_referrals' | translate"
    [subheading]="'app.offers.manage_referrals.dialog.enable_referrals_description' | translate"
    [icon]="'check'"
    (click)="enable()"
  >
  </rt-new-item-button>
  <rt-new-item-button
    [heading]="'app.offers.manage_referrals.dialog.disable_referrals' | translate"
    [subheading]="'app.offers.manage_referrals.dialog.disable_referrals_description' | translate"
    [icon]="'remove-circle'"
    (click)="disable()"
    class="danger-on-hover"
    margin-top
  ></rt-new-item-button>
</rt-dialog-body>
